import {
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { selectLdFlags } from '../../../redux/ld-flags';
import { IntroVideo } from '../../assessment/introduction/intro-video';
import { Icon } from '../../icon/icon';

type PropTypes = {
  color?: string;
};

export const WhatsTalkiatry = ({ color }: PropTypes) => {
  const { showIntroVideoInDialog } = useSelector(selectLdFlags);

  return (
    <>
      <Typography sx={{ mb: 3 }} color={color}>
        We're an online psychiatry practice. And we connect people with care
        that fits their needs.
      </Typography>
      {showIntroVideoInDialog && (
        <>
          <IntroVideo />
          <Typography sx={{ mt: 3, mb: 3 }} variant="h6">
            Why people choose us
          </Typography>
        </>
      )}
      <List dense disablePadding>
        <ListItem disableGutters sx={{ py: 0 }}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <Icon
              icon="AddressCard"
              htmlColor="rgba(72, 112, 131,1)"
              styleType="duotone"
              fontSize="small"
            />
          </ListItemIcon>
          <ListItemText
            primary="We take insurance"
            secondary="Expert care that's affordable"
            primaryTypographyProps={{
              color: 'rgba(72, 112, 131, 1)',
            }}
            secondaryTypographyProps={{
              color: 'default',
              variant: 'body1',
              fontSize: 'small',
            }}
          />
        </ListItem>
        <Divider sx={{ pt: 1, mb: 1 }} />
        <ListItem disableGutters sx={{ py: 0 }}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <Icon
              icon="LaptopMedical"
              htmlColor="rgba(49, 135, 191, 1)"
              styleType="duotone"
              fontSize="small"
            />
          </ListItemIcon>
          <ListItemText
            primary="100% virtual"
            secondary="Online visits from the comfort of almost anywhere"
            primaryTypographyProps={{
              color: 'rgba(49, 135, 191, 1)',
            }}
            secondaryTypographyProps={{
              color: 'default',
              variant: 'body1',
              fontSize: 'small',
            }}
          />
        </ListItem>
        <Divider sx={{ pt: 1, mb: 1 }} />
        <ListItem disableGutters sx={{ py: 0 }}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <Icon
              icon="HeadSideMedical"
              htmlColor="rgba(239,157,118,1)"
              styleType="duotone"
              fontSize="small"
            />
          </ListItemIcon>
          <ListItemText
            primary="Doctors who listen"
            secondary="Psychiatry that prioritizes you"
            primaryTypographyProps={{
              color: 'rgba(239, 157, 118, 1)',
            }}
            secondaryTypographyProps={{
              color: 'default',
              variant: 'body1',
              fontSize: 'small',
            }}
          />
        </ListItem>
      </List>
    </>
  );
};
